<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    switchFullscreen
    :fullscreen="true"
    @ok="MyHandleOk"
    @cancel="handleCancel">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :disabled="readOnly"  v-decorator="['code', validatorRules.code]" placeholder="请输入编码"></a-input>
        </a-form-item>
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :disabled="readOnly" v-decorator="['name', validatorRules.name]" placeholder="请输入名称"></a-input>
        </a-form-item>
        <a-form-item label="可申请门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-multi-select-tag type="list_multi"
                              :disabled="readOnly"
                             v-decorator="['materialStore']"
                             :trigger-change="true" dictCode="sales_physical_store,phystore_name,id"
                             placeholder="请选择可申请门店,不选择则全部适用"/>
        </a-form-item>
        <a-form-item label="分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-tree-select
            :disabled="readOnly"
            ref="treeSelect"
            placeholder="请选择物料分类"
            v-decorator="['categoryId', validatorRules.categoryId]"
            dict="bas_material_category,name,id"
            pidField="pid"
            pidValue="0"
            hasChildField="has_child">
          </j-tree-select>
        </a-form-item>
        <a-form-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :disabled="readOnly" v-decorator="['model']" placeholder="请输入规格型号"></a-input>
        </a-form-item>
        <a-form-item label="计量单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag :disabled="readOnly" type="list" v-decorator="['unitId', validatorRules.unitId]"
                             :trigger-change="true" dictCode="bas_measure_unit,name,id" placeholder="请选择计量单位"/>
        </a-form-item>
        <a-form-item label="安全库存" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number :disabled="readOnly" v-decorator="['safetyInventory', validatorRules.safetyInventory]" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="销售价格" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number :disabled="readOnly" v-decorator="['salePrice', validatorRules.salePrice]" style="width: 100%"/>
        </a-form-item>
<!--        <a-form-item label="税控编码" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--          <a-input :readOnly="readOnly" v-decorator="['taxCode']" ></a-input>-->
<!--        </a-form-item>-->
<!--        <a-form-item label="税率" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--          <a-input-number :readOnly="readOnly" v-decorator="['taxRate']" ></a-input-number>-->
<!--        </a-form-item>-->
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag :disabled="readOnly" type="list" v-decorator="['isEnabled', validatorRules.isEnabled]"
                             :trigger-change="true" dictCode="yn" placeholder="请选择是否启用"/>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :disabled="readOnly" v-decorator="['remark']"></a-input>
        </a-form-item>
    <!--    <a-form-item label="创建人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="['createBy']" ></a-input>
        </a-form-item>
        <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date disabled v-decorator="['createTime']" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="修改人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="['updateBy']" ></a-input>
        </a-form-item>
        <a-form-item label="修改时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date disabled v-decorator="['updateTime']" :trigger-change="true" style="width: 100%"/>
        </a-form-item>-->
      </a-form>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey">
        <a-tab-pane tab="功能单位映射表" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :disabled="readOnly"
            :ref="refKeys[0]"
            :loading="materiaUnitMapperTable.loading"
            :columns="materiaUnitMapperTable.columns"
            :dataSource="materiaUnitMapperTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true">

          </j-editable-table>
        </a-tab-pane>
        <a-tab-pane tab="物料多级单位映射表" :key="refKeys[1]" :forceRender="true">
          <j-editable-table
            :disabled="readOnly"
            :ref="refKeys[1]"
            :loading="basMarterialUnitTable.loading"
            :columns="basMarterialUnitTable.columns"
            :dataSource="basMarterialUnitTable.dataSource"
            :maxHeight="300"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true">
          </j-editable-table>
        </a-tab-pane>
      </a-tabs>




    </a-spin>

    <template slot="footer">
      <a-button  v-if="action=='add'||action=='edit'" @click="MyHandleOk" type="primary" >保存</a-button>
      <a-button key="cancel" @click="handleCancel">关闭</a-button>
    </template>
  </j-modal>
</template>

<script>

  import { getAction, httpAction } from '@/api/manage'
  import {FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormAndTables} from '@/utils/JEditableTableUtil'
  import pick from 'lodash.pick'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JTreeSelect from '@/components/jeecg/JTreeSelect'
  import JMultiSelectTag from "@/components/dict/JMultiSelectTag"
  import {JEditableTableMixin} from '@/mixins/JEditableTableMixin'


  export default {
    name: "BasMaterialModal",
    mixins: [JEditableTableMixin],
    components: {
      JDate,
      JDictSelectTag,
      JTreeSelect,
      JMultiSelectTag
    },
    data () {
      return {
        action: '',
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        labelCol2: {
          xs: {span: 24},
          sm: {span: 3},
        },
        wrapperCol2: {
          xs: {span: 24},
          sm: {span: 20},
        },
        addDefaultRowNum: 1,
        validatorRules: {
          code: {
            rules: [
              { required: true, message: '请输入编码!'},
            ]
          },
          name: {
            rules: [
              { required: true, message: '请输入名称!'},
            ]
          },
          unitId: {
            rules: [
              { required: true, message: '请输入计量单位!'},
            ]
          },
          categoryId: {
            rules: [
              { required: true, message: '请输入分类!'},
            ]
          },
          isEnabled: {
            rules: [
              { required: true, message: '请输入是否启用!'},
            ]
          },
          salePrice: {
            rules: [
              { pattern: /^(([1-9][0-9]*)|([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2}))$/, message: '请输入正确的金额!'},
            ]
          },
          safetyInventory: {

          },
        },
        url: {
          add: "/bas/basMaterial/add",
          edit: "/bas/basMaterial/edit",
          materiaUnitMapper: {
            list: '/bas/basMaterial/queryMateriaUnitMapperByMainId'
          },
          basMaterialUnit: {
            list: '/bas/basMaterial/queryBasMaterialUnitByMainId'
          }
        },
        refKeys: ['materiaUnitMapper','basMarterialUnitTable'],
        tableKeys: ['materiaUnitMapper','basMarterialUnitTable'],
        activeKey: 'basMarterialUnitTable',
        materiaUnitMapperTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '功能',
              key: 'module',
              type: FormTypes.select,
              dictCode:"func_module",
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: '计量单位',
              key: 'unitId',
              type: FormTypes.sel_search,
              dictCode:"bas_measure_unit,name,id",
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },
          ]
        },
        basMarterialUnitTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '计量单位',
              key: 'unitId',
              type: FormTypes.sel_search,
              dictCode:"bas_measure_unit,name,id",
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: '换算系数',
              key: 'conversionCoefficient',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            }
          ],
        },

      }
    },
    computed: {
      readOnly: function() {
        return this.action !== "add" && this.action !== "edit"
      }
    },
    methods: {
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        if (this.action === 'add') {
          this.addInit()
        }
        let fieldval = pick(this.model,'code','name','categoryId','isEnabled',
          'model','unitId','salePrice','taxCode','remark','createBy','createTime','updateBy','updateTime','materialStore','safetyInventory')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.materiaUnitMapper.list, params, this.materiaUnitMapperTable)
          this.requestSubTableData(this.url.basMaterialUnit.list, params, this.basMarterialUnitTable)
        }
      },
      addInit(){
        // 新增时默认选择全部门店
        const that = this
        const url = '/sales/salesPhysicalStore/findAllStores/'
        getAction(url).then(res => {
          if (res.success) {
            that.$nextTick(() => {
              let storeIds = "";
              if (res.result){
                res.result.forEach(function(id){
                  storeIds += id + ",";
                });
                storeIds = storeIds.substring(0,storeIds.length-1)
              }
              that.form.setFieldsValue({'materialStore': storeIds})
            })
          }
        })
        this.materiaUnitMapperTable.dataSource = [];
        this.basMarterialUnitTable.dataSource = [];
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          materiaUnitMapperList: allValues.tablesValue[0].values,
          basMaterialUnitList: allValues.tablesValue[1].values,
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
      validateFunModuleRepeat(formData){
        //功能计量单位校验
        let materiaUnitMapperList = formData.materiaUnitMapperList;
        if (materiaUnitMapperList){
          var ary = [];
          materiaUnitMapperList.forEach(function(row){
            ary.push(row.module);
          });
          var sortedAry = ary.sort();
          for(var i = 0; i < sortedAry.length - 1; i++) {
            if(sortedAry[i] == sortedAry[i + 1]) {
              throw this.$message.error("不允许重复设置功能计量单位映射");
            }
          }
        }
        let basMaterialUnit = formData.unitId;
        let basMaterialUnitList = formData.basMaterialUnitList;
        if (basMaterialUnitList){
          var ary = [];
          basMaterialUnitList.forEach(function(row){
            ary.push(row.unitId);
          });
          var sortedAry = ary.sort();
          for(var i = 0; i < sortedAry.length - 1; i++) {
            if(sortedAry[i] == sortedAry[i + 1]) {
              throw this.$message.error("不允许重复设置物料多级单位");
            }
          }
          for(var i = 0; i < sortedAry.length; i++) {
            if(sortedAry[i] == basMaterialUnit) {
              throw this.$message.error("不允许物料多级单位和基准单位相同");
            }
          }
        }
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(this.model,'code','name','categoryId','isEnabled',
          'model','unitId','salePrice','taxCode','remark','createBy','createTime','updateBy','updateTime','materialStore','safetyInventory'))
      },
      MyHandleOk () {
        debugger
        /** 触发表单验证 */
        this.getAllTable().then(tables => {
          /** 一次性验证主表和所有的次表 */
          return validateFormAndTables(this.form, tables)
        }).then(allValues => {
          if (typeof this.classifyIntoFormData !== 'function') {
            throw this.throwNotFunction('classifyIntoFormData')
          }
          let formData = this.classifyIntoFormData(allValues)
          //验证映射表中不能存在重复功能项
          this.validateFunModuleRepeat(formData);
          return this.request(formData)
        }).catch(e => {
          if (e.error === VALIDATE_NO_PASSED) {
            // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
            this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
          } else {
            console.error(e)
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }

  .ant-row.ant-form-item {
    margin-bottom: 12px;
  }
</style>
